module.exports = __webpack_public_path__ + "static/media/1002165MF.99e4be32.jpg";